import type { captureException, captureMessage } from '@sentry/sveltekit?inline';

export const captureMessageToSentry: (typeof captureMessage extends (...args: infer A) => infer R
    ? (...args: A) => Promise<R>
    : never) = async (msg, context) => {
    const Sentry = await import('@sentry/sveltekit?inline');
    return Sentry.captureMessage(msg, context);
};

export const captureExceptionToSentry: (typeof captureException extends (...args: infer A) => infer R
    ? (...args: A) => Promise<R>
    : never) = async (exception, hint) => {
    const Sentry = await import('@sentry/sveltekit?inline');
    return Sentry.captureException(exception, hint);
};
